$('.faq-item').each(function () {
    $(this).on('click', function () {
        var showtext = $(this).find('.faq-bottom');
        var icon = $(this).find('.faq-icon');
        if (showtext.hasClass('d-none')) {
            showtext.removeClass('d-none').hide();
            showtext.slideDown(500);
            icon.find('span').first().css({
                'rotate': '90deg',
                'width': '1rem',
                'margin-top': '10px'
            })
            icon.find('span').eq(1).css({
                'width': '1rem',
                'margin-top': '10px'
            })
            setTimeout(function () {
                icon.find('span').first().css({
                    'width': '1.5rem',
                    'margin-top': '0px'
                })
                icon.find('span').eq(1).css({
                    'width': '1.5rem',
                    'margin-top': '0px'
                })
            }, 400)

            $('.faq-bottom').not(showtext).each(function () {
                var $faqItem = $(this).closest('.faq-item');
                $faqItem.find('.faq-bottom').slideUp(500, function () {
                    $(this).addClass('d-none');
                    var icon = $faqItem.find('.faq-icon');
                    icon.find('span').first().css({
                        'rotate': '180deg',
                        'width': '1.5rem',
                        'margin-top': '0px'
                    })
                    icon.find('span').eq(1).css({
                        'width': '1.5rem',
                        'margin-top': '0px'
                    })
                });

            })
        } else {
            showtext.slideUp(500, function () {
                showtext.addClass('d-none');
            });
            icon.find('span').first().css({
                'width': '1rem',
                'margin-top': '10px'
            })
            icon.find('span').eq(1).css({
                'width': '1rem',
                'margin-top': '10px'
            })
            setTimeout(function () {
                icon.find('span').first().css({
                    'rotate': '180deg',
                    'width': '1.5rem',
                    'margin-top': '0px'
                })
                icon.find('span').eq(1).css({
                    'width': '1.5rem',
                    'margin-top': '0px'
                })
            }, 400)
        }
    });
});
